import {
  Dialog,
  DialogTitle,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Transition,
} from "@headlessui/react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
  CheckIcon,
  ChevronUpDownIcon,
  HomeIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/solid";
import { Fragment, useEffect, useRef, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import useLoading from "../../../hooks/useLoading";
import {
  getAdminList,
  getRemainingCount,
  getUserOrgTree,
  publishCouponToAdmin,
} from "../../../services/ api_services";
import { useNavigate } from "react-router-dom";
import { isEmpty, isEqual } from "lodash";
import RecoveryCouponDialog from "../../../components/dialogs/RecoveryCouponDialog";
import { ToastTypes } from "../../../context/ToastProvider";
import useToast from "../../../hooks/useToast";
import OrgCouponHistoryDialog from "../../../components/dialogs/OrgCouponHistoryDialog"
import { ROLES } from "../../../core/constants";
import OrgHistoryDialog from "../../../components/dialogs/OrgHistoryDialog";
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const pages = [
  { name: "관리자 관리", href: "/user", current: false },
  // { name: 'Project Nero', href: '/', current: true },
];

const searchType = [
  { name: "성명", value: "name" },
  { name: "휴대전화", value: "phone" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Admin() {
  const { showToast } = useToast();
  const { auth } = useAuth();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const adminOrgId = sessionStorage.getItem("adminOrgId");

  // const dbConfig = localStorage.getItem('X-DB-KEY');
  // const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === 'urinalysis';

  const initialCond = {
    search_word: "",
    search_type: "",
  };

  const inputAdminInfo = {
    admin_level_nm: "",
    admin_nm: "",
    admin_seq: "",
  };

  const initialCouponInfo = {
    source_user: "",
    target_user: "",
    coupon_cnt: "",
  };

  const inputRef = useRef();

  const [list, setList] = useState([]);
  const [cond, setCond] = useState(initialCond);
  const [adminInfo, setAdminInfo] = useState(inputAdminInfo);
  const [couponInfo, setCouponInfo] = useState(initialCouponInfo);
  const [selected, setSelected] = useState(searchType[0]);
  const [open, setOpen] = useState(false);
  const [remainingCount, setRemainingCount] = useState(0);
  const [showRecoveryDialog, setShowRecoveryDialog] = useState(false);
  const [selectedTableRow, setSelectedTableRow] = useState();
  const [selectedRecoveryCoupon, setSelectedRecoveryCoupon] = useState(null);
  const [orgTreeValues, setOrgTreeValues] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showHistoryPopup, setShowHistoryPopup] = useState(false);
  const [sortOrders, setSortOrders] = useState({admin_id: 'DESC'});

  const inputRefSendCouponCount = useRef();

  useEffect(() => {
    fetchAdminList();
  }, [sortOrders]);

  useEffect(() => {
    if (!open) {
      setCouponInfo(initialCouponInfo);
    } else {
      fetchRemainingCount();
    }
  }, [open]);

  useEffect(() => {
    if (!showRecoveryDialog) {
      onSearch();
    }
  }, [showRecoveryDialog]);

  useEffect(() => {
      selectUserOrgTree();
  }, []);

  const renderSortIcon = (col) => {
    const order = sortOrders[col];
    if (order === 'ASC') return <FaSortUp />;
    if (order === 'DESC') return <FaSortDown />;
    return <FaSort />;
  };

  const handleOnClickColumn = (col)  => {
    console.log('handleOnClickColumn====>',col);

    setSortOrders((prev) => {
      const current = prev[col];  // 현재 정렬 상태 확인

      if (current === undefined) {    // 초기값 없으면 바로 ASC로 추가
          return {
          ...prev,
          [col]: 'ASC',
          };
      }

      let nextOrder;
      if (current === 'ASC') nextOrder = 'DESC';
      else if (current === 'DESC') nextOrder = null;
      else nextOrder = 'ASC';

      const newSortOrders = { ...prev, [col]: nextOrder };
      if (nextOrder === null) {   // 정렬 없으면 삭제
          delete newSortOrders[col];
      }
      return newSortOrders;
    });
  };

  const selectUserOrgTree = async () => {
    try {
      const orgData = {
          org_id: typeof adminOrgId !== 'undefined' ? adminOrgId : 0,
          use_yn: "0001"
      }
      const response = await getUserOrgTree(orgData);
      const data = response.data;
      console.log("🚀 ~ getUserOrgTree ~ response:", response);

      const formattedOptions = [
          { name: "선택", id: null, name2:"" }, // null 옵션 추가
          ...data.map((item) => ({
              name: item.full_path,
              id: item.org_id.toString(),
              name2: item.org_name,
          })),
      ];
      setOrgTreeValues(formattedOptions);

    } catch (error) {
      console.error("옵션 데이터를 불러오지 못했습니다:", error);
    }
  };

  /**
   * 조회
   * @returns
   */
  const onSearch = async () => {
    await fetchAdminList();
  };

  const fetchRemainingCount = async () => {
    try {
      const response = await getRemainingCount(auth.admin_seq);
      console.log("🚀 ~ getRemainingCount ~ response:", response);
      if (response && response.status === 200) {
        setRemainingCount(response.data);
        if (inputRefSendCouponCount && inputRefSendCouponCount.current) {
          inputRefSendCouponCount.current.focus();
        }
      } else {
        setRemainingCount(0);
      }
    } catch (e) {
      console.log("e===>", e);
    }
  };

  /**
   * 관리자 전체 조회 (fetchAdminList)
   * @returns
   */
  const fetchAdminList = async () => {
    // console.log("cond", cond);
    // console.log("selected==>", selected);
    setLoading(true);

    const data = {
      source_user: auth.admin_seq,
      admin_level_cd: auth.admin_level_cd,
      search_word: cond.search_word,
      search_type: selected.value,
      org_id: adminOrgId != null ? adminOrgId : 0,
      sortOrders: sortOrders
    };

    console.log("🚀 ~ fetchAdminList ~ data:", data, "adminOrgId:", adminOrgId);
    try {
      const response = await getAdminList(data);

      console.log("🚀 ~ fetchAdminList ~ response:", response);
      if (response && response.status === 200) {
        const formattedData = response.data.map((item) => {

          item.coupon_count = item.coupon_count
            ? item.coupon_count.toLocaleString()
            : "0";
          item.passes_held_count = item.passes_held_count
            ? item.passes_held_count.toLocaleString()
            : "0";
          item.issuable_count = item.issuable_count
            ? item.issuable_count.toLocaleString()
            : "0";
          item.used_count = item.used_count
            ? item.used_count.toLocaleString()
            : "0";
          return item;
        });
        console.log("🚀 ~ fetchAdminList ~ formattedData:", formattedData);
        setList(formattedData);
      } else {
        setList([]);
      }

      setLoading(false);
    } catch (e) {
      console.log("e===>", e);
    }
  };

  /**
   * 쿠폰 발행 API
   * @returns
   */
  const sendCouponApi = async (condTmp) => {
    console.log("condTmp =>", condTmp);
    try {
      console.log("condTmp", condTmp);
      const { data, cancel, error } = await publishCouponToAdmin(condTmp);
      if (data) {
        console.log("[sendCouponApi][Data] ==> ", data);
        if (data.resultCode === 200) {
          showToast(ToastTypes.SUCCESS, "성공", "회원권이 발행되었습니다.");
          setOpen(false);
          onClear();
          onSearch();
        } else if (data.resultCode === 400) {
          showToast(ToastTypes.WARNING, "안내", data.message);
        }
      } else if (error) {
        console.log("[sendCouponApi][Error] ==> ", error);
      }
    } catch (e) {
      console.log("e===>", e);
    }
  };

  /**
   * 엔터키 이벤트
   * @returns
   */
  const handleOnKeyPress = (e) => {
    if (e.key === "Enter") {
      onSearch(); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  /**
   * 쿠폰 발행 함수
   * @returns
   */
  async function sendCoupon() {
    console.log("couponInfo.coupon_cnt => ", couponInfo.coupon_cnt);
    if (
      couponInfo.coupon_cnt === "" ||
      couponInfo.coupon_cnt < 0 ||
      couponInfo.coupon_cnt === 0
    ) {
      console.log("수량 공백임.");
      alert("수량을 입력해 주세요.");
      //console.log("couponInfo ==>", couponInfo);
    } else if (remainingCount < parseInt(couponInfo.coupon_cnt)) {
      alert("수량이 잔여 수량보다 큽니다. 확인하고 다시 입력해 주세요.");
      setCouponInfo((preVal) => {
        return {
          ...preVal,
          coupon_cnt: 0,
        };
      });
      return;
    } else {
      // eslint-disable-next-line no-restricted-globals
      const resConfirm = confirm(
        adminInfo.admin_nm +
          "한테 " +
          couponInfo.coupon_cnt +
          "개 회원권을 발행하시겠습니까?"
      );
      if (resConfirm) {
        //console.log("수량 공백 아님.");
        //console.log("couponInfo ==>", couponInfo);
        let condTmp = couponInfo;
        condTmp.source_user = auth.admin_seq;
        condTmp.target_user = adminInfo.admin_seq;
        //console.log("condTmp ==>", condTmp);
        await sendCouponApi(condTmp);
      }
    }
  }

  const onClear = () => {
    setCouponInfo(initialCouponInfo);
  };

  const handleOnClickGridRow = (row) => {
    // console.log("ROWS ==> ", row);
    if (auth) {
      // console.log("🚀 ~ handleOnClickGridRow ~ auth:", auth);
      if (
        auth.admin_level_cd === ROLES.Admin ||
        auth.admin_level_cd === ROLES.Volunteer
      ) {
        navigate("/ad/adminInfo/" + row.admin_info.admin_seq, {state: {orgtree: orgTreeValues}});
      }
    }
  };

  const handleOnChangeCouponCount = (e) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    if (rawValue.length <= 7) {
      //console.log("RAW VALUE => ", rawValue);
      setCouponInfo((preVal) => {
        return {
          ...preVal,
          coupon_cnt:
            rawValue && !isEmpty(rawValue) ? parseInt(rawValue, 10) : 0,
        };
      });
    }
  };

  const formattedCount = new Intl.NumberFormat().format(couponInfo.coupon_cnt);

  const handleOnClickOrgCouponDetail = (item) => {
    setShowPopup(true);
    setSelectedTableRow(item);
    console.log('handleOnClickOrgCouponDetail');
  };

  const handleOnClickOrgCouponHistory = (item) => {
    setShowHistoryPopup(true);
    setSelectedTableRow(item);
    console.log('handleOnClickOrgCouponHistory');
  };

  return (
    <div>
      <nav
        className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 w-full"
        aria-label="Breadcrumb"
      >
        <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
          <li className="flex">
            <div className="flex items-center">
              <a href="/" className="text-gray-400 hover:text-gray-500">
                <HomeIcon
                  className="h-5 w-5 flex-shrink-0"
                  aria-hidden="true"
                />
                <span className="sr-only">Home</span>
              </a>
            </div>
          </li>
          {pages.map((page) => (
            <li key={page.name} className="flex">
              <div className="flex items-center">
                <svg
                  className="h-full w-6 flex-shrink-0 text-gray-200"
                  viewBox="0 0 24 44"
                  preserveAspectRatio="none"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                </svg>
                <a
                  href={page.href}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                  aria-current={page.current ? "page" : undefined}
                >
                  {page.name}
                </a>
              </div>
            </li>
          ))}
        </ol>
      </nav>
      <RecoveryCouponDialog
        isOpen={showRecoveryDialog}
        onClose={() => setShowRecoveryDialog(false)}
        gridRow={selectedRecoveryCoupon}
      />

      <>
        {showPopup && (
          <OrgCouponHistoryDialog
            isOpen={showPopup}
            onClose={() => setShowPopup(false)}
            gridRow={selectedTableRow}
            orgTree={orgTreeValues}
          />
        )}
        {showHistoryPopup && (
          <OrgHistoryDialog
            isOpen={showHistoryPopup}
            onClose={() => setShowHistoryPopup(false)}
            gridRow={selectedTableRow}
            orgTree={orgTreeValues}
          />
        )}
      </>


      <div className="max-w-full mt-2 mb-2">
        <div className="mx-auto max-w-full">
          <div className="py-10">
            <div className="px-4 sm:px-6 lg:px-8 ">
              <div className="mt-5 flex justify-between border-gray-400 border p-4">
                <div className="flex w-8/12 space-x-3 sm:space-x-2 items-center">
                  <Listbox value={selected} onChange={setSelected}>
                    <div className="relative">
                      <ListboxButton className="relative w-32 cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 sm:text-sm sm:leading-6">
                        <span className="block truncate">{selected.name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronUpDownIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        </span>
                      </ListboxButton>

                      <ListboxOptions
                        transition
                        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                      >
                        {searchType.map((item) => (
                          <ListboxOption
                            key={item.id}
                            className="group relative cursor-default select-none py-2 pl-3 pr-4 text-gray-900 data-[focus]:bg-gray-100 data-[focus]:text-gray-700"
                            value={item}
                          >
                            <span
                              className={classNames(
                                isEqual(item, selected) ? "font-semibold" : "",
                                "block truncate font-normal group-data-[focus]:font-semibold"
                              )}
                            >
                              {item.name}
                            </span>

                            {isEqual(selected, item) && (
                              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-500  group-data-[focus]:text-gray-700 ">
                                <CheckIcon
                                  aria-hidden="true"
                                  className="h-5 w-5"
                                />
                              </span>
                            )}
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>
                  <div className="flex w-8/12 space-x-3 sm:space-x-2 ">
                    <input
                      ref={inputRef}
                      type="search"
                      className="block max-h-9 w-6/12  rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-400 text-sm"
                      maxLength={30}
                      onChange={(e) => {
                        setCond((prevState) => {
                          return {
                            ...prevState,
                            search_word: e.target.value.trim(),
                          };
                        });
                      }}
                      onKeyDown={handleOnKeyPress}
                    />
                  </div>
                </div>
                <div className="flex w-4/12 justify-end">
                  <div
                    className="h-20 bg-gray-200 mr-4"
                    style={{ width: "1px" }}
                  />
                  <button
                    type="button"
                    className="w-40 h-20 inline-flex items-center gap-x-1.5 justify-center whitespace-nowrap rounded-md bg-white py-2 px-5 text-lg font-semibold text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-200 caret-transparent"
                    onClick={() => {
                      onSearch();
                    }}
                  >
                    <MagnifyingGlassIcon
                      className="-ml-0.5 h-5 w-5"
                      aria-hidden="true"
                    />
                    조회
                  </button>
                </div>

              </div>
              <div className="mt-8 flow-root border-gray-400 border">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 ">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 ">
                    <table className="min-w-full divide-y divide-gray-500 caret-transparent">
                      <thead contentEditable={false}>
                        <tr className="whitespace-nowrap cursor-default caret-transparent bg-gray-200">
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-700 sm:pl-0"
                          >
                            NO
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('admin_id')}>
                            <div className="flex items-center gap-1">
                              아이디 {renderSortIcon('admin_id')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('admin_nm')}>
                            <div className="flex items-center gap-1">
                              성명 {renderSortIcon('admin_nm')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-center text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('admin_hp_no')}>
                            <div className="flex items-center gap-1">
                              휴대폰번호 {renderSortIcon('admin_hp_no')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-center text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('admin_level_cd')}>
                            <div className="flex items-center gap-1">
                              직급 {renderSortIcon('admin_level_cd')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-center text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('admin_type')}>
                            <div className="flex items-center gap-1">
                              계정상태 {renderSortIcon('admin_type')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-3 text-center text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('org_id')}>
                            <div className="flex items-center gap-1">
                              회원구분(조직) {renderSortIcon('org_id')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-3 text-center text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('total_coupon')}>
                            <div className="flex items-center gap-1">
                              총 회원권 {renderSortIcon('total_coupon')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className=" px-3 py-3.5 text-center text-sm text-sm font-semibold text-gray-700 cursor-pointer"
                            onClick={() => handleOnClickColumn('issued_coupon')}>
                            <div className="flex items-center gap-1">
                              발행 회원권 {renderSortIcon('issued_coupon')}
                            </div>
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-3 text-center text-sm font-semibold text-gray-700"
                          >
                            보유(가용) 회원권
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-3 text-center text-sm font-semibold text-gray-700"
                          >
                            사용/대기
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-3 text-left text-sm sm:pr-0 font-semibold text-gray-700"
                          >
                            발행 목록
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-3 text-left text-sm sm:pr-0 font-semibold text-gray-700"
                          >
                            히스토리
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-300">
                        {list.map((item, index) => { return (
                          <tr
                            className="hover:bg-slate-100"
                            key={item.admin_info.admin_seq}
                            onClick={() => handleOnClickGridRow(item)}
                          >
                            <td className="whitespace-nowrap py-2.5 px-3 text-center text-sm font-medium text-gray-700 sm:pl-0">
                              {index + 1}
                            </td>
                            <td className="whitespace-nowrap  text-left text-sm text-gray-800">
                              {item.admin_info.admin_id}
                            </td>
                            <td className="whitespace-nowrap text-left text-sm text-gray-800">
                              {item.admin_info.admin_nm}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {item.admin_info.admin_hp_no}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {item.admin_level_nm}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {item.admin_type_nm}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {item.org_name}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {item.total_coupon.toLocaleString('ko-KR')}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {item.issued_coupon.toLocaleString('ko-KR')}
                            </td>
                            <td className="whitespace-nowrap text-center text-sm text-gray-800">
                              {`${(item.total_coupon - item.issued_coupon).toLocaleString('ko-KR')} (${(item.total_coupon - item.issued_coupon - item.use_001).toLocaleString('ko-KR')})`}
                            </td>
                            <td className="whitespace-nowrap text-center font-semibold text-gray-800 hover:text-gray-700">
                              {`${(item.use_001 || 0).toLocaleString('ko-KR')} / ${(item.use_003 || 0).toLocaleString('ko-KR')}`}
                            </td>
                            <td ClassName = "text-center">
                              <button
                                type="button"
                                className="rounded border-stone-300 border-2 hover:border-stone-500 px-3 text-sm font-semibold text-gray-700"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOnClickOrgCouponDetail(item);
                                }}
                                >
                                  상세 관리
                                </button>
                            </td>
                            <td ClassName = "text-center">
                              <button
                                type="button"
                                className="rounded border-stone-300 border-2 hover:border-stone-500 px-3 text-sm font-semibold text-gray-700"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOnClickOrgCouponHistory(item);
                                }}
                                >
                                  히스토리
                                </button>
                            </td>
                          </tr>
                        )
                      }
                      )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10 " onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  py-4  text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      onClick={() => {
                        setOpen(false);
                        onClear();
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center px-5 sm:text-left">
                      <DialogTitle
                        as="h3"
                        className="font-medium text-gray-900 text-base"
                      >
                        회원권 발급
                      </DialogTitle>
                    </div>
                  </div>
                  <div className="justify-center py-5 px-6 sm:px-5 sm:py-5 rounded flex-col sm:flex-col space-y-2 sm:space-y-2 ">
                    <div className="w-full rounded shadow border-gray-300 border px-3 py-3 sm:col-span-2 justify-start">
                      <label className="block text-base font-semibold leading-6 text-blue-700">
                        발송인
                      </label>
                      <ul className="inline-flex w-full mt-2 columns-2 items-center">
                        <li className="w-1/5">
                          <label
                            htmlFor="source-user"
                            className="block w-30 text-sm font-medium text-gray-700"
                          >
                            발송인
                          </label>
                        </li>
                        <li className="w-3/5">
                          <input
                            type="text"
                            name="source_user"
                            id="source_user"
                            disabled
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                            value={auth.admin_name}
                          />
                        </li>
                      </ul>
                      <ul className="inline-flex w-full mt-1 columns-2 items-center">
                        <li className="w-1/5">
                          <label
                            htmlFor="source-user"
                            className="block w-30 text-sm font-medium text-gray-700"
                          >
                            직급
                          </label>
                        </li>
                        <li className="w-3/5">
                          <input
                            type="text"
                            name="source_user"
                            id="source_user"
                            disabled
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                            value={auth.admin_level_nm}
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="w-full rounded shadow border-gray-300 border px-3 py-3 sm:col-span-2 justify-start">
                      <label className="block text-base font-semibold leading-6 text-blue-700">
                        수송인
                      </label>
                      <ul className="inline-flex w-full mt-2 columns-2 items-center">
                        <li className="w-1/5">
                          <label
                            htmlFor="source-user"
                            className="block w-30 text-sm font-medium text-gray-700"
                          >
                            수송인
                          </label>
                        </li>
                        <li className="w-3/5">
                          <input
                            type="text"
                            name="source_user"
                            id="source_user"
                            disabled
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                            value={adminInfo.admin_nm}
                          />
                        </li>
                      </ul>
                      <ul className="inline-flex w-full mt-1 columns-2 items-center">
                        <li className="w-1/5">
                          <label
                            htmlFor="source-user"
                            className="block w-30 text-sm font-medium text-gray-700"
                          >
                            직급
                          </label>
                        </li>
                        <li className="w-3/5">
                          <input
                            type="text"
                            name="source_user"
                            id="source_user"
                            disabled
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm read-only:font-bold"
                            value={adminInfo.admin_level_nm}
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="w-full rounded   px-3 py-3 sm:col-span-2 justify-start">
                      <ul className="inline-flex w-full mt-2 columns-2 items-center">
                        <li className="w-1/5">
                          <label
                            htmlFor="source-user"
                            className="block w-30 text-sm font-medium text-gray-700"
                          >
                            수량
                          </label>
                        </li>
                        <li className="w-3/5">
                          <input
                            ref={inputRefSendCouponCount}
                            type="text"
                            placeholder="수량을 입력해 주세요"
                            className="block w-full text-sm rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600 focus:ring-blue-600 sm:leading-6"
                            min={"0"}
                            value={formattedCount}
                            onChange={(e) => handleOnChangeCouponCount(e)}
                          />
                        </li>
                      </ul>
                      <ul className="inline-flex w-full mt-0 columns-2 items-center">
                        <li className="w-1/5">
                          <div></div>
                        </li>
                        <li className="w-3/5 flex items-center">
                          <label
                            htmlFor="source-user"
                            className="block w-30 text-xs font-semibold text-red-700"
                          >
                            잔여 수량 :
                          </label>
                          <label
                            htmlFor="source-user"
                            className="block ml-1 w-30 text-xs font-bold text-gray-700"
                          >
                            {remainingCount}
                          </label>
                        </li>
                      </ul>
                    </div>
                    <div className="flex justify-center">
                      <button
                        type="button"
                        className="inline-flex items-center gap-x-2 mt-3 rounded-md border-gray-300 border px-12 py-3 text-sm font-semibold text-gray-700 shadow-sm hover:border-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 caret-transparent"
                        onClick={() => {
                          sendCoupon();
                        }}
                      >
                        <PaperAirplaneIcon
                          className="-ml-0.5 h-5 w-5"
                          aria-hidden="true"
                        />
                        발송하기
                      </button>
                    </div>

                    {/* <ul className="w-full">
                                            <li className="bg-gray-100 text-blue-600 font-bold px-3 py-1 mb-2 flex border-none rounded-lg">
                                                <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
                                                    발송인:
                                                </label>
                                                <p className="pl-1">{auth.admin_name}</p>
                                            </li>
                                            <li className="px-2 mb-1 text-sm flex ">
                                                <label>소속:</label>
                                                <p className="pl-1"></p>
                                            </li>
                                            <li className="px-2 mb-7 text-sm flex">
                                                <label>직급:</label>
                                                <p className="pl-1"></p>
                                            </li>
                                            <li className="bg-gray-100 text-blue-600 font-bold px-3 py-1 mb-2 flex border-none rounded-lg">
                                                <label>수송인:</label>
                                                <p className="pl-1">{adminInfo.admin_nm}</p>
                                            </li>
                                            <li className="px-2 mb-1 text-sm flex ">
                                                <label>소속:</label>
                                                <p className="pl-1"> </p>
                                            </li>
                                            <li className="px-2 mb-7 text-sm flex">
                                                <label>직급:</label>
                                                <p className="pl-1">{adminInfo.admin_level_nm}</p>
                                            </li>
                                            <li className="bg-gray-100 text-blue-600 font-bold px-3 py-1 mb-2 flex border-none rounded-lg">
                                                <label>수량</label>
                                            </li>
                                            <li>
                                                <input
                                                    type="number"
                                                    placeholder="수량을 입력해 주세요"
                                                    className="block w-full rounded-md border-0 px-3.5 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-visible:outline  focus-visible:outline-blue-600   focus:ring-blue-600 sm:leading-6"
                                                    onChange={(e) => {
                                                        setCouponInfo((preVal) => {
                                                            return {
                                                                ...preVal,
                                                                coupon_cnt: e.target.value,
                                                            };
                                                        });
                                                    }}
                                                />
                                            </li>
                                            <li className="text-center mt-6">
                                                <button
                                                    type="button"
                                                    className="mt-3 rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-gray-700 shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                                    onClick={() => {
                                                        sendCoupon();
                                                    }}
                                                >
                                                    발송하기
                                                </button>
                                            </li>
                                        </ul> */}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
